import './ring.css';
import React from 'react';
import PropTypes from 'prop-types';
import { clsx } from '../utils';

const Ring = ({
  className,
  color,
  size,
  style,
  thickness
}) => {
  const varStyle = { ...style
  };
  color && (varStyle['--rcs-ring-color'] = color);
  size && (varStyle['--rcs-ring-size'] = `${size}px`);
  thickness && (varStyle['--rcs-ring-thickness'] = `${thickness}px`);
  return /*#__PURE__*/React.createElement("div", {
    className: clsx('rcs-ring', className),
    style: varStyle
  }, /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement("div", null));
};

process.env.NODE_ENV !== "production" ? Ring.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.number,
  style: PropTypes.object,
  thickness: PropTypes.number
} : void 0;
export default Ring;